import { darken } from '@mui/material';
import { tss } from 'tss-react/mui';

import { VMP_VULNERABILITY_COLORS } from '@/constants/chartcolors.constants';
import type { CriticalityTypes } from '@/pages/VulnerabilityManagement/VulnerabilityManagement.types';
import type { ThemeMode } from '@/types/theme.ts';

const useStyles = tss
  .withParams<{
    severity: CriticalityTypes;
    themeMode: ThemeMode;
  }>()
  .create(({ severity, themeMode }) => ({
    chip: {
      position: 'relative',
      overflow: 'visible',
      textTransform: 'capitalize',
      border: '1px solid',
      borderColor:
        themeMode === 'light' && severity.toUpperCase() === 'MEDIUM'
          ? darken(
              VMP_VULNERABILITY_COLORS[
                severity.toUpperCase() as CriticalityTypes
              ],
              0.3
            )
          : VMP_VULNERABILITY_COLORS[
              severity.toUpperCase() as CriticalityTypes
            ],
      color:
        themeMode === 'light' && severity.toUpperCase() === 'MEDIUM'
          ? darken(
              VMP_VULNERABILITY_COLORS[
                severity.toUpperCase() as CriticalityTypes
              ],
              0.3
            )
          : VMP_VULNERABILITY_COLORS[severity.toUpperCase() as CriticalityTypes]
    }
  }));

export default useStyles;
